import { filter, isNotNil } from "ramda";
import { useContext, useEffect } from "react";
import { TITLE_SEPARATOR } from "../config.js";
import TitleContext from "./TitleContext.js";
export default function useTitlePart(title, separator = TITLE_SEPARATOR) {
    const parents = useContext(TitleContext);
    useEffect(() => {
        document.title = filter(isNotNil, [...[title].flat(), ...[parents].flat()]).join(separator);
        return () => {
            document.title = filter(isNotNil, [parents].flat()).join(separator);
        };
    }, [
        title,
        parents,
    ]);
}
